import { useState } from 'react';
import { Check, Loader2, Send } from 'lucide-react';
import { sendPressLetterTo } from '@generated/server/pressLetters';
import { getStaffPass } from '@generated/hooks/staffPass';

/** Sends letter 1 to just this one person (any status), then marks them "Letter Sent". */
export function PressSendOne({ rowId, label, hasEmail, onSent }: { rowId: string; label: string; hasEmail: boolean; onSent: () => void }) {
  const [state, setState] = useState<'idle' | 'armed' | 'sending' | 'sent' | 'failed'>('idle');
  async function go() {
    if (state !== 'armed') { setState('armed'); return; }
    setState('sending');
    try {
      const r = await sendPressLetterTo({ data: { pass: getStaffPass(), letterNumber: 1, rowId, force: true } });
      if (r?.status === 'sent') { setState('sent'); onSent(); } else setState('failed');
    } catch (e) { console.error(e); setState('failed'); }
  }
  if (!hasEmail) return null;
  const text = { idle: 'Send letter 1', armed: `Send to ${label}?`, sending: 'Sending…', sent: 'Sent', failed: 'Failed - try again' }[state];
  return (
    <button type="button" onClick={go} disabled={state === 'sending' || state === 'sent'} aria-label={`Send letter 1 to ${label}`}
      className={`inline-flex min-h-11 items-center gap-2 border-2 border-foreground px-3 text-sm font-semibold disabled:opacity-60 ${state === 'armed' ? 'bg-primary text-primary-foreground' : state === 'failed' ? 'border-destructive text-destructive' : 'bg-card hover:bg-muted'}`}>
      {state === 'sending' ? <Loader2 className="h-4 w-4 animate-spin" /> : state === 'sent' ? <Check className="h-4 w-4" /> : <Send className="h-4 w-4" />}{text}
    </button>
  );
}
